"use client";
import React from 'react';
import { motion } from 'framer-motion';

const industries = [
    'SaaS & Technology Companies',
    'Startups Building Digital Products',
    'Mobile App Companies',
    'Ecommerce Businesses',
    'Enterprise Platforms',
    'Healthcare & Education Technology',
    'Businesses Looking To Improve Conversions',
];

const IndustryPill = ({ label }: { label: string }) => (
    <span
        className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mr-2 mb-2"
        style={{
            background: 'rgba(55,48,163,0.08)',
            color: '#3730a3',
            fontFamily: 'var(--font-manrope), Manrope, sans-serif',
            border: '1px solid rgba(55,48,163,0.18)',
            letterSpacing: '0.04em',
        }}
    >
        {label}
    </span>
);

export default function UXCore() {
    return (
        <section className="relative bg-white overflow-hidden py-24 px-6 md:px-16 lg:px-24">
            <div className="absolute inset-0 pointer-events-none" style={{
                backgroundImage: 'radial-gradient(circle, rgba(55,48,163,0.07) 1.5px, transparent 1.5px)',
                backgroundSize: '32px 32px',
                maskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
                WebkitMaskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
            }} />
            <div className="absolute top-0 right-0 pointer-events-none" style={{ width: 420, height: 420, background: 'radial-gradient(circle, rgba(55,48,163,0.06) 0%, transparent 70%)', transform: 'translate(30%, -30%)' }} />

            <div className="max-w-[1400px] mx-auto flex flex-col gap-16 relative z-10">

                <div className="flex flex-col md:flex-row gap-16 items-start">

                    {/* Left */}
                    <div className="flex-1 flex flex-col gap-5">
                        <motion.span
                            initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
                            className="text-xs font-bold tracking-[0.2em] uppercase"
                            style={{ color: '#3730a3', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                        >
                            Who We Work With
                        </motion.span>
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
                            className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-none"
                            style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#3730a3' }}
                        >
                            Who We<br />Work With
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.15 }}
                            className="text-base md:text-lg max-w-md"
                            style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(8,4,0,0.55)', letterSpacing: '0.02em' }}
                        >
                            Whether you&apos;re launching a new product or improving an existing one, we help create experiences users actually enjoy using.
                        </motion.p>
                    </div>

                    {/* Right — industry pills */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }}
                        className="flex-1 flex flex-col gap-6 justify-center"
                    >
                        <div className="flex flex-wrap">
                            {industries.map(ind => <IndustryPill key={ind} label={ind} />)}
                        </div>

                        <div style={{ height: 1, background: 'linear-gradient(90deg, #3730a3 0%, transparent 100%)', opacity: 0.15 }} />

                        <p className="text-base md:text-lg"
                            style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: '#3730a3', letterSpacing: '0.02em', fontWeight: 500 }}>
                            Whether you&apos;re launching a new product or improving an existing one, we help create experiences users actually enjoy using.
                        </p>
                    </motion.div>
                </div>

            </div>
        </section>
    );
}
